import { render } from "./priceList.vue?vue&type=template&id=6649184a"
import script from "./priceList.vue?vue&type=script&lang=js"
export * from "./priceList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__